import React, { useEffect, useState } from 'react';
import { Select, Button, Modal } from 'antd';
import ManagePagesModal from './ManagePagesModal';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { updateApphome, addAndUpdatePages } from '../ApphomeActions';

const { Option } = Select;
const ManagePages = (props) => {
  const {
    pageView,
    enabledSkills,
    pages,
    setPages,
    apphome,
    hideCustomizeButtons,
  } = props;
  const dispatch = useDispatch();
  const [showPagesModal, setShowPagesModal] = useState(false);
  const [errors, setErrors] = useState({});
  const handleOk = async () => {
    try {
      const pagesWithErrors = {};
      pages.forEach((page) => {
        const errorObj = {};
        if (page.disabled === false && !page.name.trim()) {
          errorObj.name = 'Name is required';
        }
        if (page.disabled === false && !page.pageViewType) {
          errorObj.pageViewType = 'Page Type is required';
        }
        if (Object.keys(errorObj).length > 0) {
          pagesWithErrors[page._id] = errorObj;
        }
      });
      if (Object.keys(pagesWithErrors).length > 0) {
        setErrors(pagesWithErrors);
      } else {
        setErrors({});
        await dispatch(
          addAndUpdatePages(props.match.params.wId, apphome._id, {
            pages: pages,
          })
        );
        setShowPagesModal(false);
      }
    } catch (error) {
      setShowPagesModal(false);
    }
  };

  const handlePageView = async (value) => {
    try {
      await dispatch(
        updateApphome(props.match.params.wId, apphome._id, { pageView: value })
      );
    } catch (error) { }
  };

  return (
    <div className='manage_pages_container'>
      <div>
        <div style={{ fontSize: '14px', lineHeight: '12px', fontWeight: 400 }}>
          Choose what you want to see
        </div>
        <div style={{ marginTop: '11px' }}>
          <Select
            style={{ minWidth: '156px' }}
            value={pageView}
            onChange={(value) => {
              handlePageView(value);
            }}
            disabled={hideCustomizeButtons}
          >
            {pages
              ?.filter((pageInfo) => !pageInfo.disabled)
              ?.map((page) => (
                <Option value={page._id}>{page.name}</Option>
              ))}
          </Select>
        </div>
      </div>
      <div>
        <Button
          className='apphome_primary_buttons'
          onClick={() => setShowPagesModal(true)}
          type='primary'
          disabled={hideCustomizeButtons}
        >
          Manage pages
        </Button>
      </div>
      {showPagesModal && (
        <ManagePagesModal
          setPages={setPages}
          pages={pages}
          enabledSkills={enabledSkills}
          handleOk={handleOk}
          handleCancel={() => setShowPagesModal(false)}
          errors={errors}
        />
      )}
    </div>
  );
};

export default withRouter(ManagePages);
